import React from 'react';
import { ScrollView, View } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { Chip } from '@md-design-system/Chip';
import { colorPalette } from '@shared/config/colorsConfig';
import { useI18n } from '@shared/i18n/useI18n';
import type { TDocumentsMonthFilterProps } from '../../types';

export const DocumentsMonthFilter = ({
    options,
    selectedMonths,
    onToggleMonth,
    onClearMonths,
}: TDocumentsMonthFilterProps) => {
    const { t } = useI18n();

    return (
        <View className="flex-row items-center gap-sm pt-md pb-sm">
            <Icon name="filter" size={20} color={colorPalette.gray[500]} />
            <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerClassName="gap-sm pr-md">
                <Chip
                    label={t('documents.filter.allMonths')}
                    selected={selectedMonths.length === 0}
                    onPress={onClearMonths}
                />
                {options.map(option => (
                    <Chip
                        key={option.key}
                        label={option.label}
                        selected={selectedMonths.includes(option.key)}
                        onPress={() => onToggleMonth(option.key)}
                    />
                ))}
            </ScrollView>
        </View>
    );
};
